import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 20px;
  padding-right: 40px;
`;

export const MainContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-basis: 100%;
  gap: 20px;
`;

export const Heading = styled.h2`
  font-size: ${({ theme }) => theme.fontSizePalette.xlLarge};
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  padding-bottom: 20px;
`;

export const AccordionWrapper = styled.div`
  padding-bottom: 15px;
`;

export const KpisArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 40px;
  padding-top: 20px;
`;

export const KpiWrapper = styled.div`
  flex-basis: 50%;
  padding-right: 20px;
`;

export const KpiTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeightPalette.medium};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const KpiTitleLink = styled.a`
  cursor: pointer;
  text-decoration: underline;
  font-weight: ${({ theme }) => theme.fontWeightPalette.medium};
  color: ${({ theme }) => theme.colorPalette.turquoise.normal};
`;

export const KpiHeading = styled.div`
  display: flex;
  align-items: center;
`;

export const ExclamationMarkIcon = styled.span`
  &:after {
    content: '!';
  }
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  color: ${({ theme }) => theme.colorPalette.red};
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};
  border: 2px solid ${({ theme }) => theme.colorPalette.red};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
`;

export const GraphWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const IconsWrapper = styled.div`
  padding-left: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Result = styled.span<{ color?: string }>`
  color: ${({ theme, color }) => (color ? color : theme.colorPalette.grey.grey9)};
`;

export const ValueText = styled.span`
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const TableContainer = styled.div`
  display: inline-block;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colorPalette.white};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const TableEl = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: auto;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  table-layout: auto;
  tr:last-child td:first-child {
    border-bottom-left-radius: 4px;
  }
  tr:last-child td:last-child {
    border-bottom-right-radius: 4px;
  }
`;

export const HeaderRow = styled.thead``;

export const DataRow = styled.tr`
  &:not(:last-child) td {
    border-bottom: none;
  }
`;

export const Cell = styled.td`
  min-width: 100px;
  max-width: 300px;
  padding: 12px 16px;
  word-break: break-word;
  white-space: normal;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  border: solid 1px ${({ theme }) => theme.colorPalette.grey.grey5};
  background-color: ${({ theme }) => theme.colorPalette.white};
  vertical-align: middle;
  &:not(:last-child) {
    border-right: none;
  }
  &:not(:first-child) {
    border-left: none;
  }
`;

export const HeaderCell = styled.th`
  min-width: 100px;
  max-width: 300px;
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};
  padding: 12px 16px;
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  background-color: ${({ theme }) => theme.colorPalette.grey.grey2};
  border: solid 1px ${({ theme }) => theme.colorPalette.grey.grey5};
  border-bottom: none;
  &:first-child {
    border-top-left-radius: 4px;
  }
  &:last-child {
    border-top-right-radius: 4px;
  }
  &:not(:last-child) {
    border-right: none;
  }
  &:not(:first-child) {
    border-left: none;
  }
`;

export const IconHeaderCell = styled(HeaderCell)`
  width: 48px;
  min-width: 48px;
  max-width: 48px;
`;

export const IconCell = styled(Cell)`
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  text-align: center;
  vertical-align: middle;
`;
